(() => {
  const root = document.querySelector('.gb-buy-layout');
  if (!root || root.dataset.gbAddonBridge) return;
  root.dataset.gbAddonBridge = 'ready';
  const strings = JSON.parse(root.querySelector('[id^="gb-addon-strings-"]').textContent);
  let bound = false;
  let managedClick = false;
  let busy = false;
  const cartRoot = window.Shopify?.routes?.root || '/';
  const selectedChocolates = () => root.querySelector('.ppa-prod-container-grid input:checked');
  const button = () => root.querySelector('product-form button[name="add"]');
  const showError = message => {
    let error = root.querySelector('.gb-addon-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'gb-addon-error';
      error.setAttribute('role', 'alert');
      button()?.closest('.product-form__buttons')?.append(error);
    }
    error.textContent = message + ' ';
    const link = document.createElement('a');
    link.href = cartRoot + 'cart';
    link.textContent = strings.view_cart;
    error.append(link);
    error.hidden = false;
  };
  const reset = () => {
    busy = false;
    root.removeAttribute('aria-busy');
    const submit = button();
    if (submit) {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
    window.bcpo?.$?.('.r-apps-loader').addClass('r-apps-loader--hidden');
  };
  const bind = () => {
    if (bound || !window.bcpo?.$) return bound;
    window.bcpo.$(document).on('bcpo:beforeAddToCart.gulbaanAddonBridge', (event, mainData) => {
      if (!managedClick || !selectedChocolates()) return;
      busy = true;
      root.setAttribute('aria-busy', 'true');
      const submit = button();
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }
      const error = root.querySelector('.gb-addon-error');
      if (error) error.hidden = true;
      Promise.resolve().then(async () => {
        const widget = root.querySelector('lb-upsell-product-page-addon');
        if (typeof widget?.getAddedItems !== 'function') throw new Error(strings.loading);
        const selection = await widget.getAddedItems();
        const gifts = selection?.addedItems || [];
        const expected = root.querySelectorAll('.ppa-prod-container-grid input:checked').length;
        if (gifts.length !== expected) throw new Error(strings.selection);
        if ((selection.discounts || []).some(discount => Number(discount.value || discount.amount || 0) > 0)) {
          throw new Error(strings.offer);
        }
        const main = { properties: {} };
        for (const [name, value] of mainData.entries()) {
          if (typeof value !== 'string') throw new Error(strings.attachment);
          const property = name.match(/^properties\[(.*)\]$/);
          if (property) main.properties[property[1]] = value;
          else if (['id', 'quantity', 'selling_plan'].includes(name)) main[name] = value;
        }
        main.id = Number(main.id);
        main.quantity = Number(main.quantity || 1);
        if (!main.id || !Number.isInteger(main.quantity) || main.quantity < 1) throw new Error(strings.choices);
        const items = [main, ...gifts.map(gift => ({ id: Number(gift.selectedVariantId), quantity: Number(gift.quantity || 1) }))];
        if (items.some(item => !item.id || !Number.isInteger(item.quantity) || item.quantity < 1)) throw new Error(strings.selection);
        const response = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items) || items.some(item => !result.items.some(added => Number(added.variant_id || added.id) === item.id))) {
          throw new Error(result.description || strings.uncertain);
        }
        window.location.assign(cartRoot + 'cart');
      }).catch(error => {
        reset();
        showError(error.message || strings.uncertain);
      });
      return true;
    });
    bound = true;
    return true;
  };
  document.addEventListener('click', event => {
    const submit = event.target.closest?.('button[name="add"]');
    if (!submit || !root.contains(submit)) return;
    if (!busy && !selectedChocolates()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    if (!bind() || typeof window.bcpo?.addToCartClick !== 'function') {
      showError(strings.loading);
      return;
    }
    managedClick = true;
    try {
      window.bcpo.addToCartClick(event);
    } finally {
      managedClick = false;
    }
  }, true);
  bind();
})();
